import { render, staticRenderFns } from "./PneusForm.vue?vue&type=template&id=1a926147&scoped=true&"
import script from "./PneusForm.vue?vue&type=script&lang=js&"
export * from "./PneusForm.vue?vue&type=script&lang=js&"
import style0 from "./PneusForm.vue?vue&type=style&index=0&id=1a926147&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a926147",
  null
  
)

export default component.exports